/**
 * How far the OpenDock PDF reports question has been answered for this session.
 *
 * The answer is deliberately three-way rather than a boolean: the nav item must
 * not appear and then disappear, so anything short of a settled `granted` keeps
 * it out of the menu.
 *
 * - `pending`: no answer yet, the caller should render a placeholder.
 * - `granted`: the org has performance reports.
 * - `denied`: the org is not allowlisted, or the answer could not be obtained.
 */
export type OpenDockReportsAccessState = 'pending' | 'granted' | 'denied'

export function resolveOpenDockPdfReportsAccess({
  hasSession,
  isOpenDock,
  isFlagLoading,
  isFlagEnabled,
  accessState,
}: {
  hasSession: boolean
  isOpenDock: boolean
  isFlagLoading: boolean
  isFlagEnabled: boolean | null
  accessState: OpenDockReportsAccessState
}) {
  const flagOn = isFlagEnabled === true
  const shouldFetch = !isFlagLoading && hasSession && isOpenDock && flagOn

  return {
    shouldFetch,
    isNavVisible: shouldFetch && accessState === 'granted',
    isLoading: isFlagLoading || (shouldFetch && accessState === 'pending'),
  }
}
